
import React from 'react';
import { 
  Home, 
  Briefcase, 
  User, 
  Code2, 
  Mail,
  Linkedin,
  GithubIcon
} from 'lucide-react';
import { Section } from '../types';

interface SidebarProps {
  activeSection: Section;
  onSectionChange: (section: Section) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ activeSection, onSectionChange }) => {
  const menuItems = [
    { id: Section.Home, label: 'Home', icon: Home },
    { id: Section.Work, label: 'Work', icon: Briefcase },
    { id: Section.Skills, label: 'Skills', icon: Code2 },
    { id: Section.About, label: 'About', icon: User },
    { id: Section.Contact, label: 'Contact', icon: Mail },
  ];

  return (
    <aside className="hidden md:flex w-64 flex-col h-full border-r border-white/5 bg-zinc-950/20 backdrop-blur-xl">
      <div className="p-8 pb-4">
        <h1 className="text-xl font-bold tracking-tighter text-white uppercase italic">Sanket<span className="text-red-500">.</span></h1>
        <p className="text-[10px] text-zinc-500 font-medium uppercase tracking-[0.2em] mt-1">Full Stack Developer</p>
      </div>

      <nav className="flex-1 px-4 py-8 space-y-1">
        {menuItems.map((item) => (
          <button
            key={item.id}
            onClick={() => onSectionChange(item.id)}
            className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 group ${
              activeSection === item.id 
                ? 'bg-white/5 text-white shadow-[inset_0_1px_0_0_rgba(255,255,255,0.05)]' 
                : 'text-zinc-500 hover:text-white hover:bg-white/5'
            }`}
          >
            <item.icon className={`w-4 h-4 ${activeSection === item.id ? 'text-red-500' : 'group-hover:text-red-500'}`} />
            <span>{item.label}</span>
          </button>
        ))}
      </nav>

      <div className="p-4 border-t border-white/5">
        <div className="flex justify-around items-center px-4 py-4">
          <a
            href="https://github.com/SanketRSalve"
            target="_blank"
            rel="noreferrer"
            aria-label="GitHub"
            className="text-zinc-500 hover:text-white transition-colors"
          >
            <GithubIcon size={16} />
          </a>
          <a
            href="https://www.linkedin.com/in/sanketsalve/"
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn"
            className="text-zinc-500 hover:text-white transition-colors"
          >
            <Linkedin size={16} />
          </a>
          {/* <a href="#" className="text-zinc-500 hover:text-white transition-colors"><Twitter size={16}/></a> */}
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
